import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value", "data-test", "placeholder", "disabled"]

import i18n from 'frontcore/i18n'
import InputHelperText from "frontcore/views/select/InputHelperText.vue"
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { ref, watch } from 'vue'

interface Props {
  dataTest?: string
  error?: string
  placeholder?: string
  supportingText?: string
  value: string
  disabled?: boolean
}

type Emits = (e: 'input', value: string | undefined) => void

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBox',
  props: {
    dataTest: { default: 'search-box-input' },
    error: {},
    placeholder: { default: '' },
    supportingText: {},
    value: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global

const props = __props

const actualPlaceholder = props.placeholder !== '' ? props.placeholder : `${t('common.messages.search')}...`
const emit = __emit

const searchText = ref(props.value)

const cleanSearchHandler = () => {
  emit('input', '')
}

watch(
  () => props.value,
  (newVal) => searchText.value = newVal
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-text__container", [{'input-text__state-disabled': _ctx.disabled}]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        { 'disabled': _ctx.disabled },
        'input-text__input-container',
        'tw-gap-2',
        'body--body-01',
        'tw-border-core-neutral-cold-80 tw-bg-core-neutral-cold-100',
        'focus-within:tw-bg-core-primary-99 focus-within:tw-border-core-primary-50'
      ])
    }, [
      _createElementVNode("input", {
        value: searchText.value,
        class: "search-box-input tw-grow focus-within:tw-bg-core-primary-99 focus:tw-outline-none",
        "data-test": _ctx.dataTest,
        placeholder: _unref(actualPlaceholder),
        disabled: _ctx.disabled,
        onInput: _cache[0] || (_cache[0] = (e) => emit('input', e.target.value))
      }, null, 40, _hoisted_1),
      (!searchText.value)
        ? (_openBlock(), _createBlock(SVGIcon, {
            key: 0,
            colorClass: _ctx.disabled ? 'tw-fill-core-neutral-cold-50' : 'tw-fill-primary-10',
            iconName: "SearchFill0",
            remSize: 1.25
          }, null, 8, ["colorClass"]))
        : _createCommentVNode("", true),
      (searchText.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            "data-test": "search-box-close-button",
            onClick: _withModifiers(cleanSearchHandler, ["stop"])
          }, [
            _createVNode(SVGIcon, {
              iconName: "Close",
              colorClass: "tw-fill-core-neutral-cold-20",
              remSize: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(InputHelperText, {
      error: _ctx.error,
      supportingText: _ctx.supportingText
    }, null, 8, ["error", "supportingText"])
  ], 2))
}
}

})